<template>
  <div class="text-left filtros">
    
    <div class="pr-2">
      <button
        class="btn btn-link btn-block btn-sm text-danger"
        @click="onClickApagarFiltros"
      >Apagar filtros</button>
    </div>
    <hr class="my-2"/>

    <label>Bicicletas:</label>

    <div>
      <b-form-radio v-model="selecionados.condicao" name="condicao-bike" value>Todas</b-form-radio>
      <b-form-radio
        v-model="selecionados.condicao"
        name="condicao-bike"
        :value="config.CONDICAO_BIKE_NOVA"
      >Novas</b-form-radio>
      <b-form-radio
        v-model="selecionados.condicao"
        name="condicao-bike"
        :value="config.CONDICAO_BIKE_USADA"
      >Usadas</b-form-radio>
    </div>
    <hr />
    <div class="pr-2">
      <label>Marca ou Modelo:</label>
      <input
        type="text"
        class="form-control border-primary"
        placeholder="Ex. Elite 30"
        :value="selecionados.termoPesquisa"
        @input="debounceTermoPesquisa"
      />
      <!-- <div class="input-group mb-3">
        <input
          type="text"
          class="form-control border-primary"
          placeholder="Ex. Elite 30"
          :value="selecionados.termoPesquisa"
          @input="debounceTermoPesquisa"
        />
        <div class="input-group-append">
          <span class="input-group-text btn-pesquisar">
            <b-icon icon="search" class="mr-1"></b-icon>
          </span>
        </div>
      </div>-->
    </div>

    <hr />
    <div class="pr-2">
      <label>Estado:</label>
      <select class="form-control border-primary" v-model="selecionados.estado">
        <option value>Todos</option>
        <option v-for="(texto,id) in dados.uf" :key="'estado'+id" :value="id">{{texto}}</option>
      </select>
    </div>

    <hr />
    <div class="pr-2">
    <label>Preço (R$):</label>
     <select class="form-control border-primary" v-model="selecionados.preco">
        <option value="">Todos</option>
        <option value="0-400">Até R$400</option>
        <option value="400-800">R$400 a R$800</option>
        <option value="800-1200">R$800 a R$1.200</option>
        <option value="1200-2000">R$1.200 a R$2.000</option>
        <option value="2000-3000">R$2.000 a R$3.000</option>
        <option value="3000-5000">R$3.000 a R$5.000</option>
        <option value="5000-10000">R$5.000 a R$10.000</option>
        <option value="10000-20000">R$10.000 a R$20.000</option>
        <option value="20000-50000">R$20.000 a R$50.000</option>
        <option value="50000-">Acima de R$50.000</option>
      </select>
    </div>

    <!-- <hr />
    <label>Avaliação Bike Registrada:</label>
    <b-form-checkbox-group
      v-model="selecionados.estrelas"
      :options="getEstrelasOptions()"
      name="avaliacao-estrelas"
      stacked
    ></b-form-checkbox-group> -->

    <hr />
    <label>Quadro:</label>
    <b-form-checkbox-group
      v-model="selecionados.quadro"
      :options="helper.getOptions(dados.tipoQuadro)"
      name="tipo-quadro"
      stacked
    ></b-form-checkbox-group>

    <hr />
    <label>Aro:</label>
    <b-form-checkbox-group
      v-model="selecionados.aro"
      :options="helper.getOptions(dados.tipoAro)"
      name="tipo-aro"
      stacked
    ></b-form-checkbox-group>

    <hr />
    <label>Modalidade:</label>
    <b-form-checkbox-group
      v-model="selecionados.modalidade"
      :options="helper.getOptions(dados.tipoBike)"
      name="tipo-bike"
      stacked
    ></b-form-checkbox-group>

    <hr />
    <div class="pr-2">
      <button
        class="btn btn-link btn-block btn-sm text-danger"
        @click="onClickApagarFiltros"
      >Apagar filtros</button>
    </div>
  </div>
</template>

<script>

import helper from "../helpers/helper";
import config from "../config";

export default {
  props: ["dados", "selecionados"],
  components:{},
  data() {
    return {
      helper,
      config,
    };
  },
  methods: {
    getEstrelasOptions() {
      var options = [];
      for (var i = 5; i > 0; i--) {
        var estrelasHtml = '<img src="/img/ico_star.svg" width="16" class="mr-2" />'.repeat(
          i - 1
        );
        estrelasHtml += '<img src="/img/ico_star.svg" width="16"/>';

        var optionItem = { value: i, html: estrelasHtml };
        options.push(optionItem);
      }

      return options;
    },

    onClickApagarFiltros() {
      this.$emit("limpar");
    },

    debounceTermoPesquisa(ev) {
      var debounceId = "debounceTermoPesquisa";
      if (window[debounceId]) {
        clearTimeout(window[debounceId]);
      }
      window[debounceId] = setTimeout(() => {

        this.$set(this.selecionados, 'termoPesquisa', ev.target.value);
        //this.selecionados.termoPesquisa = ev.target.value;
      }, 1618);
    }
  }
};
</script>

<style lang="less" scoped>
@import "../styles/variaveis";

.filtros {
  font-size: 14px;
  // border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.apagar-filtros:hover {
  opacity: 0.9;
}

label {
  font-weight: 700;
  font-size: 14px;
}

.btn-pesquisar {
  border-color: @primary-color;
  background-color: @primary-color;
  color: white;
}

.border-primary {
  border-color: @primary-color !important;
}

.filtro-preco{
  font-size: 0.9rem;
}
</style>